module.exports = __webpack_public_path__ + "img/Fried chicken Icon - white.8aa484f9.svg";